module.exports = __webpack_public_path__ + "static/bubble-4edd85ceb3813e9a0c00b62586035619.png";